// import Item Img
import Item1 from "../../assets/img/destination/main-page1.png"
import Item2 from "../../assets/img/destination/main-page2.png"
import Item3 from "../../assets/img/destination/main-page3.png"
import Item4 from "../../assets/img/destination/main-page4.png"
import Item5 from "../../assets/img/destination/main-page5.png"
import Item6 from "../../assets/img/destination/main-page6.png"

export const DestinationData = [
    {
        img:Item1,
        heading:"Ancient egypt",
        reviewRating:"4.8/5 Excellent",
        reviewCount:"(1214 reviewes)",
        price:"$99.00"
    },
    {
        img:Item2,
        heading:"Explore china",
        reviewRating:"4.8/5 Excellent",
        reviewCount:"(1214 reviewes)",
        price:"$99.00"
    },
    {
        img:Item3,
        heading:"Annapurna",
        reviewRating:"4.8/5 Excellent",
        reviewCount:"(1214 reviewes)",
        price:"$99.00"
    },
    {
        img:Item4,
        heading:"Beautiful darjeeling",
        reviewRating:"4.8/5 Excellent",
        reviewCount:"(1214 reviewes)",
        price:"$99.00"
    },
    {
        img:Item5,
        heading:"Himalaya",
        reviewRating:"4.8/5 Excellent",
        reviewCount:"(1214 reviewes)",
        price:"$99.00"
    },
    {
        img:Item6,
        heading:"Kathmundu",
        reviewRating:"4.8/5 Excellent",
        reviewCount:"(1214 reviewes)",
        price:"$99.00"
    }

]